// src/components/FormField.jsx
//
// A labeled text input. No box chrome — just a label above a hairline.
// Used for username, password, and 2FA code (with a right-side slot for
// the TOTP ring on the 2FA field).

export default function FormField({
  label,
  hint,
  type = "text",
  value,
  onChange,
  onKeyDown,
  autoFocus,
  autoComplete = "off",
  spellCheck = false,
  inputMode,
  maxLength,
  rightSlot,
}) {
  return (
    <div className="space-y-2">
      <label className="block font-mono text-[11px] tracking-[0.16em] uppercase text-aught-ash">
        {label}
      </label>
      <div className="flex items-end gap-4 hairline focus-within:border-aught-oxide transition-colors duration-200 ease-out-soft">
        <input
          type={type}
          value={value}
          onChange={onChange}
          onKeyDown={onKeyDown}
          autoFocus={autoFocus}
          autoComplete={autoComplete}
          spellCheck={spellCheck}
          inputMode={inputMode}
          maxLength={maxLength}
          className="flex-1 font-serif text-2xl text-aught-ink placeholder-aught-ash/40"
          placeholder=""
        />
        {rightSlot}
      </div>
      {hint && (
        <p className="font-mono text-[11px] text-aught-ash tabular">
          {hint}
        </p>
      )}
    </div>
  );
}
